document.addEventListener('DOMContentLoaded', function () {
    const images = [
        'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/poster1.png?v=1732565039',
        'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/poster2.png?v=1732565039',
        'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/poster3.png?v=1732565039',
        'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/poster5.png?v=1732565039',
        'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/poster6.png?v=1732565039'
    ];

  const randomImage = images[Math.floor(Math.random() * images.length)];
    const homeContent = document.querySelector('.home-content');

    if (!homeContent) {
        console.error('Element with class "home-content" not found.');
        return;
    }

    // Create an image element with transition
    const imgElement = document.createElement('img');
    imgElement.src = randomImage;
    imgElement.alt = 'Randomized content';
    imgElement.className = 'transition-image'; // Add class for transition effect

    // Clear existing content and add the new image
    homeContent.innerHTML = '';
    homeContent.appendChild(imgElement);

    // Trigger the animation (optional, if needed to force animation re-render)
    requestAnimationFrame(() => imgElement.classList.add('reveal'));
});
